import { AxiosResponse } from 'axios';

export const extractData = <Data>({ data }: AxiosResponse<Data>) => data;
